export default {
  RemoveFeedbackCriterion: 'معیار بازخورد حذف شد',
  FeedbackCriterionUpdate: 'معیار بازخورد بروزرسانی شد',
  NewFeedbackCriterionAdd: 'معیار بازخورد جدید اضافه شد',
  StatusChange: 'وضعیت تغیر کرد',
  FeedbackResponseChange: ' پاسخ بازخورد تغیر کرد',
  ResponseTime: 'تاریخ پاسخ',
  RespondeTimeMin: 'تاریخ پاسخ از',
  RespondeTimeMax: 'تاریخ پاسخ تا',
  Accepted: 'تایید شده',
  FeedbackCriterion: 'معیار بازخوردم',
  Disable: 'غیر فعال',
  CreationTime: 'تاریخ ثبت',
  FeedbackResponse: 'پاسخ بازخورد',
  Status: 'وضعیت',
  FeedbackText: 'متن بازخورد',
  Title: 'عنوان',
  UserName: 'نام کاربر',
  Feedback: 'بازخورد',
  FeedbackTitle: 'عنوان بازخورد',
  ClientMobilePhone: 'تلفن همراه مشتری',
  Enabled: 'فعال',
  SortOrder: 'ترتیب',
  WaitingForConfirmation: 'منتظر تایید',
  Rejected: 'ردشده',
  Slug: 'Slug',
  FinalRating: 'امتیاز نهایی',
  approveFeedback: 'تایید بازخورد',
  rejectFeedback: 'رد کردن بازخورد',
  changeToPending: 'تغییر به در انتظار بررسی',
  changeToInProgress: 'تغییر به در حال بررسی',
  areYouSureYouWantToDeleteThisFeedback:
    'آیا از حذف این بازخورد اطمینان دارید؟',
  areYouSureYouWantToApproveThisFeedback:
    'آیا از تایید این بازخورد اطمینان دارید؟',
  areYouSureYouWantToRejectThisFeedback:
    'آیا از رد کردن این بازخورد اطمینان دارید؟',
  areYouSureYouWantToChangeThisFeedbackStateToPending:
    'آیا از تغییر وضعیت این بازخورد به در انتظار بررسی اطمینان دارید؟',
  areYouSureYouWantToChangeThisFeedbackStateToInProgress:
    'آیا از تغییر وضعیت این بازخورد به در حال بررسی اطمینان دارید؟',
  feedbackResponseSuccessfullyRegistered: 'پاسخ بازخورد با موفقیت ثبت شد',

  feedbackResponse: 'پاسخ بازخورد',
  creationTime: 'زمان ثبت بازخورد',
  responseTime: 'تاریخ پاسخ',
  feedback: 'بازخورد',
  clientMobilePhone: 'تلفن همراه مشتری',
  feedbackText: 'متن بازخورد',
  addFeedback: 'افزودن بازخورد',
  editFeedback: 'ویرایش بازخورد',
  response: 'پاسخ'
}
